import { getChatBubbles } from 'widget/api/management';

export const actions = {
  getChatBubbles: async ({ commit }, { inboxId, locale }) => {
    commit('setManagementUiFlags', { isLoading: true });
    try {
      const { data } = await getChatBubbles(inboxId, locale);

      commit('setChatBubbles', data);
    } catch (error) {
      // Ignore error
    } finally {
      commit('setManagementUiFlags', { isLoading: false });
    }
  },
};
